export enum DifficultType {
  none = "",
  master = "MASTER",
  practice = "PRACTICE",
  warmup = "WARMUP"
}

export enum QuestionCategory {
  none = "",
  intro = 'INTRO',
  random = 'RANDOM',
  rhyme = 'RHYME',
  challenges = 'CHALLENGES',
  spellingbee = 'SPELLINGBEE',
  puzzle = 'PUZZLE',
}

export enum Action {
  none = "NONE",
  drag = 'DRAG',
  click = 'CLICK',
}


export enum QuestionType {
  none = "",
  mcq = 'MCQ',
  match = 'MATCH',
  dragMatch = 'DRAGMATCH',
  fill = 'FILL',
}

export enum OptionWithImage {
  none = "",
  yes = "Yes",
  no = "No"
}